
import { defineComponent } from 'vue'
import Tracker from '@/components/Tracker/Tracker.vue'

export default defineComponent({
  name: 'IPAddressTracker',
  components: {
    Tracker,
  },
})
